module.exports = __webpack_public_path__ + "img/pic_1_tc.20d8bb5c.png";